import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { withTheme } from '@material-ui/core/styles';
import { TextField as TextFieldComponent } from 'components/TextField/TextField';
import { Select as SelectComponent } from 'components/Select/Select';

export const DialogBase = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    padding: 25px;
    border-radius: 4px;
    max-width: 400px;
  }
`;

export const DialogTitle = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 0;
  color: #6a758b;
  height: 24px;
  margin-bottom: 29px;
`;

export const DialogContentText = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: medium;
  font-size: 16px;
  padding-top: 15px;
  color: rgba(0, 0, 0, 0.8);
  width: 330px;
`;

export const FormWrapper = styled.div`
  padding-top: 15px;
  transition: height 0.3s ease;
  overflow-y: hidden;
`;

export const TextField = withTheme(styled(TextFieldComponent)`
  && {
    margin-top: ${(props): number => props.theme.spacing(1)}px;
    width: 100%;
  }
`);

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
`;

export const ButtonWrapper = styled.div`
  height: 45px;
  margin-left: 10px;
`;

export const SelectContainer = styled.div`
  margin-top: 8px;
  max-width: 380px;
  height: 39px;
`;

export const SelectWrapper = styled(SelectComponent)`
  min-height: 0px;
  margin: 0;
  width: 350px;
`;
